import type { StateCreator } from 'zustand';
import type {
  BasicInfo,
  ContactDetails,
  IdentificationInfo,
  Patient,
  PatientSliceType,
  PatientState,
  RedFlagInfo,
} from '../types';

export const setPatient: StateCreator<
  PatientState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: Partial<Patient>) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient = { ...state.patient, ...attributes };
    },
    false,
    'patient/setPatient',
  );
};

export const setPatientBasicInfo: StateCreator<
  PatientSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: Partial<BasicInfo>) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.basicInfo = { ...state.patient.basicInfo, ...attributes };
    },
    false,
    'patient/setPatientBasicInfo',
  );
};

export const setPatientContactDetails: StateCreator<
  PatientSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: Partial<ContactDetails>) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.contactDetails = { ...state.patient.contactDetails, ...attributes };
    },
    false,
    'patient/setPatientContactDetails',
  );
};

export const setPatientIdentificationInfo: StateCreator<
  PatientState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: Partial<IdentificationInfo>) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.identificationInfo = { ...state.patient.identificationInfo, ...attributes };
    },
    false,
    'patient/setPatientIdentificationInfo',
  );
};

export const setPatientRedFlagInfo: StateCreator<
  PatientState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (attributes: RedFlagInfo) => void
> = (set) => (attributes) => {
  set(
    (state) => {
      state.patient.redFlagInfo = { ...state.patient.redFlagInfo, ...attributes };
    },
    false,
    'patient/setPatientRedFlagInfo',
  );
};

export const setPatientIhiVerification: StateCreator<
  PatientState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (needsVerification: boolean) => void
> = (set) => (needsVerification) => {
  set(
    (state) => {
      state.patient.needsIhiVerification = needsVerification;
    },
    false,
    'patient/setPatientIhiVerification',
  );
};
